// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Redirect = require("../../reason/common/Redirect.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let UnifiedProfileSettingsUI = require("./UnifiedProfileSettingsUI.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let UnifiedTeamAccountProfileMemberRow = require("./UnifiedTeamAccountProfileMemberRow.bs.js");
let UnifiedTeamAccountProfileMembersSettingsQuery_graphql = require("../../__generated__/UnifiedTeamAccountProfileMembersSettingsQuery_graphql.bs.js");

let convertVariables = UnifiedTeamAccountProfileMembersSettingsQuery_graphql.Internal.convertVariables;

let convertResponse = UnifiedTeamAccountProfileMembersSettingsQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedTeamAccountProfileMembersSettingsQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, UnifiedTeamAccountProfileMembersSettingsQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, UnifiedTeamAccountProfileMembersSettingsQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(UnifiedTeamAccountProfileMembersSettingsQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(UnifiedTeamAccountProfileMembersSettingsQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(UnifiedTeamAccountProfileMembersSettingsQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(UnifiedTeamAccountProfileMembersSettingsQuery_graphql.node, convertVariables);

let Query_accountMemberRole_decode = UnifiedTeamAccountProfileMembersSettingsQuery_graphql.Utils.accountMemberRole_decode;

let Query_accountMemberRole_fromString = UnifiedTeamAccountProfileMembersSettingsQuery_graphql.Utils.accountMemberRole_fromString;

let Query = {
  accountMemberRole_decode: Query_accountMemberRole_decode,
  accountMemberRole_fromString: Query_accountMemberRole_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function UnifiedTeamAccountProfileMembersSettings(props) {
  let data = use(undefined, undefined, undefined, undefined);
  let canManageVisibility = data.currentAccountV5.viewerProfileRole === "OWNER";
  let profile = data.currentAccountV5.profile;
  switch (profile.__typename) {
    case "IndividualAccountProfile" :
      return JsxRuntime.jsx(Redirect.make, {
        path: "/account/account_profile"
      });
    case "TeamAccountProfile" :
      let memberEdges = Stdlib_Array.filterMap(profile.members.edges, edge => edge);
      let userRows = Stdlib_Array.filterMap(memberEdges, edge => {
        let member = edge.node;
        switch (member.__typename) {
          case "DisplayOnlyMember" :
            return;
          case "UserBoundMember" :
            return JsxRuntime.jsx(UnifiedTeamAccountProfileMemberRow.User.make, {
              member: member.fragmentRefs,
              canManageVisibility: canManageVisibility
            }, member.nodeId);
          case "__unselected" :
            return UnselectedUnionMemberError.raise(`Unselected profile member: ` + member._0);
        }
      });
      let displayOnlyRows = Stdlib_Array.filterMap(memberEdges, edge => {
        let member = edge.node;
        switch (member.__typename) {
          case "DisplayOnlyMember" :
            return JsxRuntime.jsx(UnifiedTeamAccountProfileMemberRow.DisplayOnly.make, {
              member: member.fragmentRefs
            }, member.nodeId);
          case "UserBoundMember" :
            return;
          case "__unselected" :
            return UnselectedUnionMemberError.raise(`Unselected profile member: ` + member._0);
        }
      });
      return JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(UnifiedProfileSettingsUI.SubpageHeader.make, {
            title: "Members",
            rootName: "Your Team's Profile",
            rootUrl: "/account/account_profile",
            url: "/account/account_profile/members"
          }),
          JsxRuntime.jsxs("section", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("h3", {
                        children: "Users",
                        className: "text-xl font-semibold text-zinc-800"
                      }),
                      JsxRuntime.jsx(ButtonsV5.Link.make, {
                        href: "/account/users",
                        size: "small",
                        children: "Manage account users"
                      })
                    ],
                    className: "flex flex-wrap items-center justify-between gap-3"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Account members with a TAN login. Their profile data is managed from their own Your Profile settings.",
                    className: "text-base text-zinc-500"
                  })
                ],
                className: "space-y-2"
              }),
              userRows.length !== 0 ? JsxRuntime.jsx("ul", {
                  children: userRows,
                  className: "divide-y divide-zinc-200 rounded-lg border border-zinc-200 px-4",
                  role: "list"
                }) : JsxRuntime.jsx("div", {
                  children: "There are no linked users on this team profile.",
                  className: "rounded-lg border border-dashed border-zinc-300 bg-zinc-50 p-8 text-center text-zinc-500"
                })
            ],
            className: "space-y-4"
          }),
          JsxRuntime.jsxs("section", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("h3", {
                        children: "Display-only",
                        className: "text-xl font-semibold text-zinc-800"
                      }),
                      JsxRuntime.jsx("p", {
                        children: "People shown on the team profile who do not have a TAN login.",
                        className: "max-w-2xl text-base text-zinc-500"
                      })
                    ],
                    className: "space-y-2"
                  }),
                  JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                    href: "/account/account_profile/members/new",
                    size: "small",
                    children: "Add Display-only member"
                  })
                ],
                className: "flex flex-col justify-between gap-4 sm:flex-row sm:items-end"
              }),
              displayOnlyRows.length !== 0 ? JsxRuntime.jsx("ul", {
                  children: displayOnlyRows,
                  className: "divide-y divide-zinc-200 rounded-lg border border-zinc-200 px-4",
                  role: "list"
                }) : JsxRuntime.jsx("div", {
                  children: "No Display-only members have been added.",
                  className: "rounded-lg border border-dashed border-zinc-300 bg-zinc-50 p-8 text-center text-zinc-500"
                })
            ],
            className: "space-y-4 border-t border-zinc-200 pt-8"
          }),
          JsxRuntime.jsx(UnifiedProfileSettingsUI.FormActions.make, {
            publicUrl: profile.publicUrl,
            viewLabel: "View team profile",
            showSave: false
          })
        ],
        className: "space-y-8 rounded bg-white p-6 shadow-sm"
      });
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected account profile member: ` + profile._0);
  }
}

let make = UnifiedTeamAccountProfileMembersSettings;

exports.Query = Query;
exports.make = make;
/* use Not a pure module */
